import {
    getUserRecord,
    postAddUserRecord,
    postUpdateUserRecord,
    postDeleteUserRecord,
    uploadRecordImage
} from './user_record';
import { postLogin } from './login';

export const API_GET_USER_RECORD = getUserRecord;
export const API_POST_ADD_USER_RECORD = postAddUserRecord;
export const API_POST_UPDATE_USER_RECORD = postUpdateUserRecord;
export const API_POST_DELETE_USER_RECORD = postDeleteUserRecord;
export const API_POST_LOGIN = postLogin;
export const API_UPLOAD_RECORD_IMAGE = uploadRecordImage;